import React from 'react';
import { FileText, Link2, File } from 'lucide-react';
import { EMPTY_ILLUSTRATION_FLOAT_STYLE, EmptyIllustrationFrame } from './empty-illustration';

export const ResourcesEmptyIllustration: React.FC = () => {
  return (
    <EmptyIllustrationFrame>
      <svg viewBox="0 0 104 76" className="absolute bottom-0 left-1/2 h-[133px] w-[182px] -translate-x-1/2" fill="none">
        <path
          d="M10 12 H46 L58 24 H94 A8 8 0 0 1 102 32 V60 A8 8 0 0 1 94 68 H10 A8 8 0 0 1 2 60 V20 A8 8 0 0 1 10 12 Z"
          fill="var(--muted)"
          stroke="var(--border)"
          strokeWidth="2"
        />
      </svg>

      <div
        className="absolute left-2.5 top-2.5 flex h-[60px] w-[60px] items-center justify-center rounded-xl border border-border bg-card shadow-sm"
        style={EMPTY_ILLUSTRATION_FLOAT_STYLE.a}
      >
        <FileText className="h-6 w-6 text-muted-foreground" />
      </div>

      <div
        className="absolute left-1/2 top-0 flex h-[60px] w-[60px] -translate-x-1/2 items-center justify-center rounded-xl shadow-sm"
        style={{ backgroundColor: 'var(--scribane-green)', ...EMPTY_ILLUSTRATION_FLOAT_STYLE.b }}
      >
        <Link2 className="h-6 w-6 text-white" />
      </div>

      <div
        className="absolute right-2.5 top-5 flex h-[60px] w-[60px] items-center justify-center rounded-xl border border-border bg-card shadow-sm"
        style={EMPTY_ILLUSTRATION_FLOAT_STYLE.c}
      >
        <File className="h-6 w-6 text-muted-foreground" />
      </div>
    </EmptyIllustrationFrame>
  );
};
